<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div>
  <fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
</div>
<div id="brand-family-container">

  <div id="header-container">
    <div>
      <h1 id="header-text">Manage Sales Lags</h1>
    </div>

    <div class="extra-buttons">
      <app-upload-button class="upload" [apiUrl]="excelService.excelSheetUrl"
                         (eventEmitter)="upload($event)"></app-upload-button>
      <app-export-button id="export-button" class="no-custom-text"
                         color="primary"
                         [excelExportService]="excelService"
                         [worksheetExportRequest]="worksheetExportRequest">
        Export
      </app-export-button>
    </div>
  </div>
  <!--    Sales Lag Report Table-->
  <div class="gfs-table">

    <ag-grid-angular
      style="height: 100%; width:100%;"
      class="ag-theme-quartz"
      [rowData]="salesLagReportData"
      [columnDefs]="columnDef"
      [autoSizeStrategy]="autoSizeStrategy"
      [pagination]="true"
      [paginationPageSize]="pageSize"
      [paginationPageSizeSelector]="[20, 50, 100, 200, 2000]"
    />
</div>


